/* ============================================================
   MUSE DISC — Discs Gallery JS
   Hover flip (GSAP) + modal on click
   ============================================================ */

(function () {
  const section  = document.getElementById('discs-gallery');
  if (!section) return;

  const discs    = section.querySelectorAll('.disc');
  const modal    = document.getElementById('disc-modal');
  const backdrop = document.getElementById('disc-modal-backdrop');
  const closeBtn = document.getElementById('disc-modal-close');
  const modalImg = document.getElementById('disc-modal-image');
  const modalPh  = document.getElementById('disc-modal-placeholder');
  const modalNum = document.getElementById('disc-modal-number');
  const modalTtl = document.getElementById('disc-modal-title');
  const modalTrk = document.getElementById('disc-modal-track');

  // Respect prefers-reduced-motion for flip animations
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Hover flip (GSAP) ------------------------------------
  if (typeof gsap !== 'undefined' && !prefersReduced) {
    discs.forEach(disc => {
      const flipper = disc.querySelector('.disc__flipper');
      if (!flipper) return;

      // Remove CSS hover rule — GSAP takes over
      flipper.style.transition = 'none';

      disc.addEventListener('mouseenter', () => {
        gsap.to(flipper, {
          rotateY: 180,
          duration: 0.55,
          ease: 'power3.out',
        });
      });

      disc.addEventListener('mouseleave', () => {
        gsap.to(flipper, {
          rotateY: 0,
          duration: 0.5,
          ease: 'power3.out',
        });
      });
    });
  }

  // --- Grid entrance (stagger) ------------------------------
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.fromTo(
      Array.from(discs),
      { opacity: 0, scale: 0.85 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: 'power3.out',
        stagger: {
          amount: 0.5,
          grid: [3, 3],
          from: 'center',
        },
        scrollTrigger: {
          trigger: section,
          start: 'top 75%',
          once: true,
        },
      }
    );
  }

  // --- Modal ------------------------------------------------
  let activeIndex = -1;

  function openModal(disc, index) {
    const name  = disc.dataset.name  || '';
    const track = disc.dataset.track || '';
    const src   = disc.dataset.image || '';
    const alt   = disc.dataset.imageAlt || name;
    const num   = String(index + 1).padStart(2, '0');

    modalNum.textContent = num;
    modalTtl.textContent = name;
    modalTrk.textContent = track;

    if (src) {
      modalImg.src = src;
      modalImg.alt = alt;
      modalImg.style.display = 'block';
      modalPh.style.display  = 'none';
    } else {
      modalImg.style.display = 'none';
      modalPh.style.display  = 'block';
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    activeIndex = index;

    // Focus close button for accessibility
    requestAnimationFrame(() => closeBtn.focus());
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');

    // Return focus to the disc that opened the modal
    if (activeIndex >= 0) discs[activeIndex]?.focus();
    activeIndex = -1;
  }

  discs.forEach((disc, i) => {
    disc.addEventListener('click', () => openModal(disc, i));
  });

  if (backdrop) backdrop.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  // Keyboard: Escape to close, arrow keys to navigate
  document.addEventListener('keydown', e => {
    if (!modal.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
    }

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      const next = (activeIndex + 1) % discs.length;
      openModal(discs[next], next);
    }

    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = (activeIndex - 1 + discs.length) % discs.length;
      openModal(discs[prev], prev);
    }
  });
})();
